import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'jt-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

	constructor(
    public router: Router
  ) { }

	ngOnInit() {
	}

  returnDashboard() {
    this.router.navigate(['main/dashboard']);
  }

}
